import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface AvailableTechnician {
  id: number;
  email: string;
  slug: string;
  label: string;
}

export const getAvailableTechnicians = async () => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get('client-technicals/', {
    headers: {
      Authorization: token,
    },
  });

  return data.data as AvailableTechnician[];
};
